import React, { useEffect, useMemo, useState } from "react";
import ProcedureDiagnosisService from "./procedureDiagnosisService";
import "./ProcedureDiagnosisSelector.css";

const procedureService = new ProcedureDiagnosisService();

const ProcedureDiagnosisSelector = () => {
  const params = new URLSearchParams(window.location.search);

  const typeParam = params.get("type") || "diagnosis";
  const inputTargetParam = params.get("inputTarget") || typeParam;

  const type = typeParam.toLowerCase();

  const [items, setItems] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const fetchItems = async () => {
    try {
      setLoading(true);

      const data = await procedureService.getAllProcedures();

      const expectedDifferenceCode = type === "diagnosis" ? "d" : "p";

      const filtered = Array.isArray(data)
        ? data.filter(
            (item) =>
              String(item.differenceCode || "").toLowerCase() ===
              expectedDifferenceCode
          )
        : [];

      setItems(filtered);
    } catch (err) {
      alert("❌ Failed to load codes");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredItems = useMemo(() => {
    const cleanQuery = query.trim().toLowerCase();

    if (!cleanQuery) {
      return items;
    }

    return items.filter((item) => {
      const code = String(item.code || "").toLowerCase();
      const description = String(item.description || "").toLowerCase();

      return code.includes(cleanQuery) || description.includes(cleanQuery);
    });
  }, [items, query]);

  const handleSelect = (item) => {
    if (!item?.code) {
      return;
    }

    const code = String(item.code).trim();

    window.opener?.postMessage(
      {
        inputTarget: inputTargetParam,
        value: code,
        displayName: code,
        selectedItem: item,
      },
      "*"
    );

    window.close();
  };

  const title = type === "diagnosis" ? "Diagnosis" : "Procedure";

  return (
    <div className="selector-wrapper">
      <div className="selector-container">
        <h2>Select {title}</h2>

        <input
          className="search-input"
          type="text"
          placeholder="Search by code or description"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoFocus
        />

        {loading ? (
          <p>Loading codes...</p>
        ) : (
          <div className="table-wrapper">
            <table className="code-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Description</th>
                </tr>
              </thead>

              <tbody>
                {filteredItems.map((item) => (
                  <tr
                    key={item.code}
                    className="selector-clickable-row"
                    onClick={() => handleSelect(item)}
                    title={`Select ${item.code}`}
                  >
                    <td>{item.code}</td>
                    <td>{item.description}</td>
                  </tr>
                ))}

                {filteredItems.length === 0 && (
                  <tr>
                    <td colSpan="2">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <button className="close-button" onClick={() => window.close()}>
          Close
        </button>
      </div>
    </div>
  );
};

export default ProcedureDiagnosisSelector;